module.exports = __webpack_public_path__ + "img/carousel_img_sp.ef6221d0.jpg";